import React from 'react';
import classes from 'classnames';
import styles from './ChartsWrapper.module.scss';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';

interface ChartsWrapperProps {
  title?: string;
  subTitle?: string;
  tools?: any;
  children?: any;
  onSelect?: () => void;
}

const ChartsWrapper: React.FC<ChartsWrapperProps> = ({
  title,
  subTitle,
  tools,
  children,
  onSelect,
}) => {
  return (
    <div
      className={classes(styles.wrapper)}
      onClick={onSelect}
      style={{
        cursor: onSelect ? 'pointer' : 'default',
      }}
    >
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.title}>{title}</div>
          {!!subTitle && <div className={styles.subTitle}>{subTitle}</div>}
        </div>
        {!!tools && <div className={styles.tools}>{tools}</div>}
        {!!onSelect && (
          <span className={styles.rightArrow} aria-hidden='true'>
            <AppIcon icon='arrowRight' width={24} height={24} />
          </span>
        )}
      </div>
      <div className={styles.chart}>{children}</div>
    </div>
  );
};

export default ChartsWrapper;
